/**
 * Created by 11 on 2017/2/17.
 */


export default{
    install(Vue){
        Vue.prototype.getcookie=function(name) {
            if(name=='username'){
                name="username_client";
            }
            var arr = document.cookie
                .match(new RegExp("(^| )" + name + "=([^;]*)(;|$)"));
            if (arr != null)
                return unescape(arr[2]);
            return null;
        }
        Vue.prototype.savecookie=function(name, value,days) {
            // var days = 1;// cookie保存1天
            var dat = new Date();
            dat.setTime(dat.getTime() + days * 24 * 60 * 60 * 1000);
            document.cookie = name + "=" + escape(value) + ";path=/;expires="
                + dat.toGMTString();
        }
        Vue.prototype.delCookie=function(name)
        {
            var exp = new Date();
            exp.setTime(exp.getTime() - 1);
            var cval=getCookie(name);
            if(cval!=null)
                document.cookie= name + "="+cval+";expires="+exp.toGMTString();
        }
        Vue.prototype.tenant_id="000001";
        Vue.prototype.isUser=0 //开启一个人登陆 0 多人登陆
        //自定义全局常量
        //孚迅图片地址
        Vue.prototype.fusionImageUrl="https://litian.s3.cn-north-1.amazonaws.com.cn/";


        //Vue.prototype.requetHost="http://192.168.10.29:9100/signage";
        //Vue.prototype.requetHost="https://mp.antgine.com/signage";
        Vue.prototype.requetHost="http://47.99.129.28:9100/signage";

        //商品服务消费者
        Vue.prototype.productURL="https://mp.antgine.com";
        //Vue.prototype.productURL="https://antgine.paybay.cn";
        //Vue.prototype.productURL="http://192.168.10.29:8765";

        Vue.prototype.fileURL="https://mp.antgine.com";
        //Vue.prototype.fileURL="https://antgine.paybay.cn";


        //广告
        Vue.prototype.adserver = 'https://mp.antgine.com/delivery'
        //Vue.prototype.adserver = 'https://antgine.paybay.cn/delivery'
        Vue.prototype.fileHost = 'http://retail.paybay.cn/sharefile'
        //Vue.prototype.fileHost = 'https://antgine.paybay.cn/sharefile'
        //Vue.prototype.uploadHost = 'http://47.99.129.28/activity'
        Vue.prototype.uploadHost = 'https://mp.antgine.com/delivery'
        //Vue.prototype.uploadHost = 'https://antgine.paybay.cn/delivery'
        // Vue.prototype.fusionToken = '011lcnzoq2nshdPaluIKsnll919'

        Vue.prototype.requetCodeHost="https://mp.antgine.com/delivery";
        //Vue.prototype.requetCodeHost="https://antgine.paybay.cn/delivery";
        //Vue.prototype.requetCodeHost="http://47.99.129.28:80/discountActivity";
        Vue.prototype.actManagerHost="https://mp.antgine.com";
        //Vue.prototype.actManagerHost="https://antgine.paybay.cn";
       // Vue.prototype.actManagerHost="http://localhost:8765";
        /*王峰活动管理接口*/
        Vue.prototype.findActListURL = "/vueFeign/admin/activity/find/list";
        /*王峰创建活动*/
        Vue.prototype.createActURL = "/vueFeign/admin/activity/save";
        /*根据活动ID查询活动信息*/
        Vue.prototype.getActInfoURL = "/vueFeign/admin/activity/find/info";
        /*修改活动*/
        Vue.prototype.postUpdateActInfoURL = "/vueFeign/admin/activity/modify";
        /*删除活动*/
        Vue.prototype.deleteActInfoURL = "/vueFeign/admin/activity/delete";
        /*暂停或开启活动*/
        Vue.prototype.startOrPaseActURL = "/vueFeign/admin/activity/modify/status";
        /*查询已选择设备*/
        Vue.prototype.getValidDeviceURL ="/vueFeign/admin/activity/machine/find/list";
        /*验证活动名称*/
        Vue.prototype.checkActNameURL ="/vueFeign/admin/activity/verify/name";
        /*添加设备*/
        Vue.prototype.addDeviceURL = "/vueFeign/admin/activity/machine/save";
        /*删除设备*/
        Vue.prototype.deleteDeviceURL = "/vueFeign/admin/activity/machine/delete";
        /*根据活动编号查询应用信息*/
        Vue.prototype.findAppInfoURL = "/vueFeign/admin/activity/app/find/info";
        /*新增应用*/
        Vue.prototype.addAppInfoURL = "/vueFeign/admin/activity/app/save";
        /*修改应用*/
        Vue.prototype.updateAppInfoURL = "/vueFeign/admin/activity/app/modify";



        /** 微页面请求地址 **/
         Vue.prototype.homePageHost='https://mp.antgine.com';
         //Vue.prototype.homePageHost='https://antgine.paybay.cn';
        //Vue.prototype.homePageHost='http://127.0.0.1:8765';
        /** 微页面分页查询URL **/
        Vue.prototype.findHomePageListURL = "/vueFeign/component/findPageInfos";
        /** 复制页面信息URL **/
        Vue.prototype.copyPageUrl= '/vueFeign/component/copyPageInfo';
        /** 设为主页URL **/
        Vue.prototype.setHomePageUrl= '/vueFeign/component/setHomePage';
        /** 复制页面信息URL **/
        Vue.prototype.delPageUrl= '/vueFeign/component/delPageInfoById';
        /** 新增页面信息URL **/
        Vue.prototype.saveHomePageUrl= '/vueFeign/component/savePageInfo';
        /** 修改页面信息URL **/
        Vue.prototype.updateHomePageUrl= '/vueFeign/component/updatePageInfo';
        /** 查询页面信息URL **/
        Vue.prototype.findHomePageInfoUrl= '/vueFeign/component/findPageInfoById';

        /** 设备请求Host **/
        //Vue.prototype.deviceHost='https://migu.antgine.com';
        Vue.prototype.deviceHost='https://mp.antgine.com';
        //Vue.prototype.deviceHost='https://antgine.paybay.cn';
        //Vue.prototype.deviceHost='http://127.0.0.1:8765';
        /** 分页查询设备列表 **/
        Vue.prototype.findDeviceListURL='/vueFeign/findDevices';
        /** 删除设备 **/
        Vue.prototype.delDeviceUrl='/vueFeign/delDevice';
        /** 新增设备URL **/
        Vue.prototype.saveDeviceUrl='/vueFeign/saveDevice';
        /** 修改设备URL **/
        Vue.prototype.validateDeviceIdUrl='/vueFeign/validateDeviceId';
        /** 修改设备URL **/
        Vue.prototype.validateDeviceNameUrl='/vueFeign/validateDeviceName';
        /** 查询设备URL **/
        Vue.prototype.findDeviceUrl='/vueFeign/findDeviceById';
        /** 修改设备URL **/
        Vue.prototype.updateDeviceUrl='/vueFeign/updateDevice';

       // Vue.prototype.requetCodeHost="http://47.99.129.28:8080/delivery";

       //Vue.prototype.admin_host = "https://migu.antgine.com/vueFeign";
       Vue.prototype.admin_host = "https://mp.antgine.com/vueFeign";
       //Vue.prototype.admin_host = "https://antgine.paybay.cn/vueFeign";

      // Vue.prototype.admin_host = "http://localhost:8780/marketing";
       // Vue.prototype.admin_host = "http://localhost:8765/vueFeign";
        //自定义全局常量
        Vue.prototype.publickey= "MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQDSdEPtJpLsyBn0PpQ5CxzewzvYKA1R3E1mAKt0juBMhLmcZqJS0x0u0DVfeR6qOi3RLf71F9rFQZHFRVDRU2CmOxOevGD9Zb8VllBRSoAq20QkTuYxYc+zztgVevwqiDQNlNmW2EpDm7605ZPFje+fZF5jZu+i6EcOjGgMLx97XwIDAQAB";



    }
}





// WEBPACK FOOTER //
// ./src/store/base.js